import { TFunction } from 'i18next';
import { Target } from 'shared/assets/icons';
import { Option } from 'shared/components/ui/custom-form-multi-select';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';
import { FilterOptionKeys } from 'shared/types/filter-document';
import { Goal } from 'shared/types/goal';
import { getSubGoals } from 'shared/utils/get-sub-goals';
import { sortGoals } from 'shared/utils/sort-goals';

export type Options = {
  t: TFunction;
};

const buildGoalOptions = (goal: Goal, allGoals: Goal[]): Option => {
  const childGoals = sortGoals(getSubGoals(goal.id, { goals: allGoals }), {
    allGoals,
    sortMode: goal.goalSortingMode,
    customOrder: goal.goalSorting,
  });

  const children = childGoals.map((childGoal) =>
    buildGoalOptions(childGoal, allGoals),
  );

  return {
    label: goal.name,
    value: goal.id,
    children: children.length ? children : undefined,
  };
};

export const createGoalFilter = (
  goals: Goal[],
  { t }: Options,
): FilterSelectOption[] => {
  if (!goals.length) {
    return [];
  }

  const mainGoals = goals.filter((goal) => !goal.parentIds?.length);
  const groupedOptions = mainGoals.map((goal) => buildGoalOptions(goal, goals));

  if (!groupedOptions.length) {
    return [];
  }

  return [
    {
      id: FilterOptionKeys.Goal,
      label: t('context-menus.filtering.task.filters.goals.title'),
      placeholder: t('general.labels.select'),
      icon: Target,
      type: FilterOptionType.MultiSelect,
      selectOptions: groupedOptions,
      recursiveSelection: true,
    },
  ];
};
